// src/InlineError.tsx
import Box from "@mui/material/Box/index.js";
import Typography from "@mui/material/Typography/index.js";
import Button from "@mui/material/Button/index.js";
import { jsx, jsxs } from "react/jsx-runtime";
var InlineError = ({
  message = "Couldn't load this content.",
  onRetry
}) => {
  return /* @__PURE__ */ jsxs(Box, { sx: { py: 4, textAlign: "center" }, children: [
    /* @__PURE__ */ jsx(Typography, { color: "text.secondary", sx: { mb: onRetry ? 1 : 0 }, children: message }),
    onRetry && /* @__PURE__ */ jsx(Button, { size: "small", onClick: onRetry, children: "Try again" })
  ] });
};

export {
  InlineError
};
